import { FormGroup, Label, Col, FormFeedback } from 'reactstrap'
import { Controller } from 'react-hook-form'
import '../ManualUploads.css'

const ManualUploadsDateTime = ({
  name,
  id = `${name}Input`,
  control,
  errors,
  defaultValue = undefined,
  required,
  visible,
  label
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref }
      }) => {
        return (
          <FormGroup className='date-time'>
            <Col className='manual-uploads-col'>
              <Label for={`${name}_input`} className='manual-uploads-label'>
                {label}
              </Label>
              <input
                type='datetime-local'
                id={`${name}_input`}
                name={name}
                ref={ref}
                className='manual-uploads-input form-control'
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                //required={required}
              />
              <FormFeedback
                valid={errors?.[name] ? false : true}
                role='alert'
                id={`${name}Error`}
                style={visible ? { display: 'block' } : { display: 'hidden' }}
              >
                {errors?.[name]?.message}
              </FormFeedback>
            </Col>
          </FormGroup>
        )
      }}
    />
  )
}

export default ManualUploadsDateTime
